import React from 'react';
import { CookiesProvider } from 'react-cookie';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';

import createStore from 'modules/redux/store';
import App from './App';

import 'modules/theme/sass/_index.scss';

// Redirect the app completely to PeopleCert before rendering any UI.
if (typeof window !== 'undefined') {
  window.location.replace('https://www.peoplecert.org/');
}

const store = createStore();

ReactDOM.render(
  <React.StrictMode>
    <CookiesProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </CookiesProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
